import { useState } from 'react';
import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

interface AppLayoutProps {
  children?: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-[#0b1326] text-pesage-primary">
      <aside className="sticky top-0 hidden h-screen w-[240px] shrink-0 lg:block">
        <Sidebar />
      </aside>

      {mobileSidebarOpen && (
        <div className="fixed inset-0 z-40 bg-slate-950/70 backdrop-blur-sm lg:hidden" onClick={() => setMobileSidebarOpen(false)}>
          <div
            className="h-full w-[min(88vw,240px)]"
            onClick={(event) => event.stopPropagation()}
          >
            <Sidebar onNavigate={() => setMobileSidebarOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col bg-[radial-gradient(circle_at_top,_rgba(30,41,59,0.45),_transparent_38%),linear-gradient(180deg,_#0f172a_0%,_#091224_100%)]">
        <Topbar onOpenSidebar={() => setMobileSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto px-4 py-5 sm:px-6 sm:py-6 lg:px-8">
          {children}
        </main>
      </div>
    </div>
  );
}
